import { render, staticRenderFns } from "./UserProfileEditDemographic.vue?vue&type=template&id=b550d616"
import script from "./UserProfileEditDemographic.vue?vue&type=script&lang=js"
export * from "./UserProfileEditDemographic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports